<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_HIGH_TECH_LIST_MPT'
        )
      }"
    >
      <tags-input
        @tags-updated="
          $parent.$parent.removeError(
            'PROJECTS',
            'LOGIC',
            'UF_HIGH_TECH_LIST_MPT'
          )
        "
        element-id="tags"
        v-model="selectedTags"
        :existing-tags="tags"
        :only-existing-tags="true"
        @tag-added="onTagAdded"
        @tag-removed="onTagRemoved"
        placeholder="Добавить объект"
        :typeahead="true"
        :disabled="$parent.$parent.projectDisabled"
      ></tags-input>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_HIGH_TECH_LIST_MPT"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORY } from "@/store/actions.type";

export default {
  name: "HighTechListMPT",
  data() {
    return {
      selectedTags: [],
      tagsLoaded: false
    };
  },
  created() {
    this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_high_technology_mpt1863"])
      .then(() => {
        this.project.UF_HIGH_TECH_LIST_MPT.forEach(function(cId) {
          this.directory.sp_high_technology_mpt1863.forEach(function(c) {
            if (cId === c.ID) {
              this.selectedTags.push(c.NAME);
            }
          }, this);
        }, this);
        this.tagsLoaded = true;
      }, this);
  },
  methods: {
    onTagAdded(slug) {
      if (slug >= 0) {
        this.project.UF_HIGH_TECH_LIST_MPT.push(
          this.directory.sp_high_technology_mpt1863[parseInt(slug)].ID
        );
      }
    },
    onTagRemoved(slug) {
      let rem = 0;
      if (slug.length > 8) {
        this.directory.sp_high_technology_mpt1863.forEach(function(c) {
          if (c.NAME === slug) {
            rem = c.ID;
          }
        });
      } else {
        let onTagRemovedName = this.directory.sp_high_technology_mpt1863[slug]
          .NAME;
        this.directory.sp_high_technology_mpt1863.forEach(function(c) {
          if (c.NAME === onTagRemovedName) {
            rem = c.ID;
          }
        });
      }
      if (rem > 0) {
        this.project.UF_HIGH_TECH_LIST_MPT.forEach(function(c, index) {
          if (rem === c) {
            this.project.UF_HIGH_TECH_LIST_MPT.splice(index, 1);
          }
        }, this);
      }
    }
  },
  computed: {
    tags() {
      let tags = {};
      this.directory.sp_high_technology_mpt1863.forEach(function(el, k) {
        tags[k] = el.NAME;
      }, this);
      return tags;
    },
    ...mapGetters(["directory", "project"])
  }
};
</script>

<style scoped></style>
